export const PRODUCTION_SURPLUS_STATUS_AVAILABLE = 'available'
export const PRODUCTION_SURPLUS_STATUS_PARTIALLY_ALLOCATED = 'partially_allocated'
export const PRODUCTION_SURPLUS_STATUS_ALLOCATED = 'allocated'
export const PRODUCTION_SURPLUS_STATUS_WRITTEN_OFF = 'written_off'

export const PRODUCTION_SURPLUS_STATUSES = [
    {value: PRODUCTION_SURPLUS_STATUS_AVAILABLE, label: 'Raspoloživo', badge: 'success'},
    {value: PRODUCTION_SURPLUS_STATUS_PARTIALLY_ALLOCATED, label: 'Djelimično alocirano', badge: 'warning'},
    {value: PRODUCTION_SURPLUS_STATUS_ALLOCATED, label: 'Alocirano', badge: 'primary'},
    {value: PRODUCTION_SURPLUS_STATUS_WRITTEN_OFF, label: 'Otpisano', badge: 'danger'},
]

export interface ProductionSurplusParams {
    page: number
    per_page: number
    status?: string
    idArtikla?: string | number
    idOperacije?: string | number
    datumOd?: string
    datumDo?: string
}

export interface ProductionSurplusItem {
    id: number
    idArtikla: number
    idOperacije: number
    idUposlenik: number
    idMasine: number
    kolicina: number | string
    raspolozivaKolicina: number | string
    trajanjeSekundi: number
    datum: string
    status: string | number
    napomena?: string
    artikal?: {
        ArtNaziv?: string
        Naziv?: string
    }
    operacija?: {
        naziv?: string
        Naziv?: string
        artikal?: {
            ArtNaziv?: string
            Naziv?: string
        }
    }
    uposlenik?: {
        UposlenikImePrezime?: string
        Naziv?: string
    }
}

export const getProductionSurplusStatus = (status?: string | number) => {
    const normalized = String(status ?? '').toLowerCase()

    return (
        PRODUCTION_SURPLUS_STATUSES.find((item) => item.value === normalized) ??
        PRODUCTION_SURPLUS_STATUSES.find((item) => item.value.replace('_', '-') === normalized) ??
        PRODUCTION_SURPLUS_STATUSES[0]
    )
}
